import { Component, Input, Output, EventEmitter, OnInit } from "@angular/core";
import { DropdownItem } from "src/app/common/interfaces/dropdown-item.interface";
import { DropdownComponent } from "src/app/common/components/core/dropdown/dropdown.component";
import { MatSelectChange } from "@angular/material/select";
@Component({
  standalone: true,
  selector: "app-corporation-selector",
  templateUrl: "./corporation-selector.component.html",
  styleUrls: ["./corporation-selector.component.scss"],
  imports: [DropdownComponent],
})
export class CorporationSelectorComponent implements OnInit {
  @Input() corporations: DropdownItem[] = [];
  @Input() set defaultCorporationId(value: string | null) {
    if (value) {
      this.selectedCorporationId = value;
    }
  }

  @Output() corporationSelected = new EventEmitter<MatSelectChange>();
  selectedCorporationId!: string;
  corporationOptions: DropdownItem[] = [];

  ngOnInit() {
    this.corporationOptions = this.corporations;
  }

  onCorporationSelected(event: any) {
    this.corporationSelected.emit(event);
  }
}
